export const packageName = 'jiraServicedeskViewsOnboarding';
export const teamName = 'jsd-shield';
export const JSM_VIEWS_NAV_ONBOARDING_KEY = 'jsm-views-nav-onboarding';
export const JSM_VIEWS_MEATBALLS_ONBOARDING_KEY = 'jsm-views-meatballs-onboarding';
